module.exports = __webpack_public_path__ + "img/tickets-big@2x.4f97d396.png";